<template>
    <div ref="canvas" class="canvas__container">
    </div>
</template>
<script>
    import * as THREE from 'three'
    import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
    import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
    import Stats from 'three/examples/jsm/libs/stats.module'
    export default {
        props : {
            src : { type : String, default : null },
            item : { type : Object, default : null },
        },
        data(){
            return { 
                camera : null,
                sceneCopy : null,
                renderer : null,
                stats : null,
                container : null,
                mixerCopy : null,
                modelSrc : null
            }
        },

        mounted(){
            console.log("props item",this.item);
            if(this.item.fbx && this.item.fbx.fileURL) {
                this.modelSrc = this.src ?  this.src : this.item.fbx.fileURL
                this.container = this.$refs.canvas
                this.init();
                this.animate();
            }
        },

        methods : {
            init() {

				this.camera = new THREE.PerspectiveCamera( 45, this.container.offsetWidth / this.container.offsetHeight, 1, 2000 );
				this.camera.position.set( 100, 200, 300 );

				let scene = new THREE.Scene();
				scene.background = new THREE.Color( 0xa0a0a0 );
				scene.fog = new THREE.Fog( 0xa0a0a0, 200, 1000 );

				const hemiLight = new THREE.HemisphereLight( 0xffffff, 0x444444 );
				hemiLight.position.set( 0, 200, 0 );
				scene.add( hemiLight );

				const dirLight = new THREE.DirectionalLight( 0xffffff );
				dirLight.position.set( 0, 200, 100 );
				dirLight.castShadow = true;
				dirLight.shadow.camera.top = 180;
				dirLight.shadow.camera.bottom = - 100;
				dirLight.shadow.camera.left = - 120;
				dirLight.shadow.camera.right = 120;
				scene.add( dirLight );

				// scene.add( new THREE.CameraHelper( dirLight.shadow.this.camera ) );

				// ground
				const mesh = new THREE.Mesh( new THREE.PlaneGeometry( 2000, 2000 ), new THREE.MeshPhongMaterial( { color: 0x999999, depthWrite: false } ) );
				mesh.rotation.x = - Math.PI / 2;
				mesh.receiveShadow = true;
				scene.add( mesh );

				const grid = new THREE.GridHelper( 2000, 20, 0x000000, 0x000000 );
				grid.material.opacity = 0.2;
				grid.material.transparent = true;
				scene.add( grid );

				// model
				const loader = new FBXLoader();
                let mixer = null;
				// loader.load( '../../../static/models/bot.fbx', function ( object ) {
				loader.load( this.modelSrc, function ( object ) {
					mixer = new THREE.AnimationMixer( object );

					const action = mixer.clipAction( object.animations[ 0 ] );
					action.play();

					object.traverse( function ( child ) {

						if ( child.isMesh ) {

							child.castShadow = true;
							child.receiveShadow = true;

						}

					} );
                    object.scale.set(.5, .5, .5)
					scene.add( object );

				} );
                this.sceneCopy = scene;
                this.mixerCopy = mixer;
				this.renderer = new THREE.WebGLRenderer();
				this.renderer.setPixelRatio( window.devicePixelRatio );
				this.renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );
				this.renderer.shadowMap.enabled = true;
				this.container.appendChild( this.renderer.domElement );

				const controls = new OrbitControls( this.camera, this.renderer.domElement );
				controls.target.set( 0, 100, 0 );
				controls.update();

				window.addEventListener( 'resize', this.onWindowResize );

				// stats
				// stats = new Stats();
				// this.container.appendChild( stats.dom );

			},
            onWindowResize() {

				this.camera.aspect = this.container.offsetWidth / this.container.offsetHeight;
				this.camera.updateProjectionMatrix();

				this.renderer.setSize( this.container.offsetWidth, this.container.offsetHeight );

			},
            animate() {
                requestAnimationFrame( this.animate );
                const clock  = new THREE.Clock()
				const delta = clock.getDelta();

				if ( this.mixerCopy ) this.mixerCopy.update( delta );

				this.renderer.render( this.sceneCopy, this.camera );

				// stats.update();

			}
        }
        
    }
</script>
<style lang="scss" scoped>
    .canvas__container {
        width : 600px;
        height : 300px;
    }
</style>


// WEBPACK FOOTER //
// src/components/global/ThreeJsViewer.vue